<ng-container *ngFor="let connection of connections">
  <svg>
    <line [attr.x1]="transformScore(connection.motiveAScore)" [attr.y1]="transformIndex(connection.motiveAIndex)"
          [attr.x2]="transformScore(connection.motiveBScore)" [attr.y2]="transformIndex(connection.motiveBIndex)"
          stroke-dasharray="3 3" [style.opacity]="selectedMotiveScore ? 0.5 : 1"/>
  </svg>
</ng-container>
